import React from 'react';
import { Link } from 'react-router-dom';
import './DirectoryPage.css';

const tiles = [
  {
    title: 'family links',
    route: '/family-links',
    color: '#00aba9',
    icon: '🔗',
  },
  {
    title: 'python curriculum',
    route: '/python-index-curriculum',
    color: '#60a917',
    icon: '🐍',
  },
  {
    title: 'go curriculum',
    route: '/go-curriculum',
    color: '#00add8',
    icon: '🐹',
  },
  {
    title: 'portfolio',
    route: '/portfolio',
    color: '#0050ef',
    icon: '💼',
  },
];

const DirectoryPage: React.FC = () => {
  return (
    <div className="directory-page">
      <div className="directory-tiles">
        {tiles.map((tile) => (
          <Link
            key={tile.route}
            to={tile.route}
            className="directory-tile"
            style={{ backgroundColor: tile.color }}
          >
            <span className="directory-tile-icon">{tile.icon}</span>
            <span className="directory-tile-label">{tile.title}</span>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default DirectoryPage;
